module.exports = __webpack_public_path__ + "img/question-mark.afd80b5f.svg";